








import { Component, Vue } from 'vue-property-decorator';
import TitleBar from '@/components/layout/TitleBar.vue';
import {SET_LAYOUT_CONFIG} from "@/store/layout_module";
import BoxTile from '@/components/ui/BoxTile.vue';

@Component({
  components: {
    BoxTile,
    TitleBar
  },
})
export default class GoalsWrapper extends Vue {

}
